import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIButton from 'UIComponents/button/UIButton';
import { PUBLIC_USER } from 'marketplace-ui-reviews/constants/UnreviewableReason';
import { getIsPublicApp } from '../../selectors/app';
import { jsx as _jsx } from "react/jsx-runtime";
export default function WriteReviewButton({
  className,
  disabled = false,
  onClick,
  size = 'sm',
  unreviewableReason,
  reviewPending
}) {
  const isPublicApp = useSelector(getIsPublicApp);
  const isReviewable = !isPublicApp && !unreviewableReason;
  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsx(UITooltip, {
      title: reviewPending ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.themes.details.reviews.unreviewable.reviewSubmitted"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: `marketplace-ui-reviews.error.${isPublicApp ? `ReviewError.${PUBLIC_USER}` : unreviewableReason}`
      }),
      disabled: reviewPending ? false : isReviewable,
      placement: "left",
      children: /*#__PURE__*/_jsx(UIButton, {
        className: className,
        onClick: onClick,
        use: "tertiary",
        size: size,
        disabled: reviewPending || disabled || !isReviewable,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.themes.details.reviews.write.button"
        })
      })
    })
  });
}